import { Component } from '@angular/core';
import { CSettingWindow, ISettingWindow } from 'projects/core/src/include/settingwindow';
import { SystemService } from 'projects/core/src/lib/system.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})

@ISettingWindow.register

export class DossierSettingsComponent extends CSettingWindow{
  tab=1;

  constructor(public systemService:SystemService){
      super(systemService);
   }

  close(){
    this['modalWindow'].close();
  }
}

